export default __webpack_public_path__ + "static/media/Magnetic Card.fb5122b5.svg";